import React, { useState, useEffect } from 'react';

import CollectionsRow from './collections-row';

import './styles/collections-table.scss';

const CollectionsTable = ({ data }) => {
  const [didMount, setDidMount] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dataRows, setDataRows] = useState([]);

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    setLoading(true);
    formatData();
  }, [data]);

  function formatData() {
    // TODO update formatData to use reduce on data
    setDataRows(
      data.map(row => {
        return { ...row, selected: false };
      }),
    );
    setLoading(false);
  }

  // Table Column Headers
  const columnHeaders = ['status', 'collection title', 'collection type', 'merchants', 'products'];
  const headerRow = !loading
    ? columnHeaders.map((columnName, idx) => {
        return (
          <div key={idx} className={`col-header ${columnName.replace(/\s/g, '-')}`}>
            {columnName}
          </div>
        );
      })
    : null;

  const collectionsList = !loading
    ? dataRows.map((row, idx) => {
        return <CollectionsRow key={idx} row={row} />;
      })
    : null;

  const collectionTable = dataRows.length ? (
    <div className="collection-table">
      <div className="header-row">
        <div className="col-header empty-col"></div>
        <span className="col-header checkbox"></span>
        {headerRow}
      </div>
      <div className="collections-list">{collectionsList}</div>
    </div>
  ) : null;

  return <div className="collections-table-container">{collectionTable}</div>;
};

export default CollectionsTable;
